

/**
 * マスタ管理ページ
 * 各種マスタデータの管理メニュー
 */

import { AdminPageWrapper, PageLayout } from '@/shared/components'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/shared/ui/breadcrumb'
import { List } from 'lucide-react'
import { Link } from 'react-router-dom'

/**
 * マスタページの設定
 */
const masterPages = [
  { href: '/masters/craftsmen', title: '職人マスタ', description: '職人情報の登録・編集を行います。' },
  { href: '/masters/company-vehicles', title: '社用車マスタ', description: '社用車情報の登録・編集を行います。' },
  { href: '/masters/trucks', title: 'トラックマスタ', description: 'トラック情報の登録・編集を行います。' },
  { href: '/masters/truck-drivers', title: 'トラック運転手マスタ', description: 'トラック運転手情報の登録・編集を行います。' },
]

/**
 * マスタ管理ページコンポーネント
 */
export default function MastersPage() {
  return (
    <AdminPageWrapper>
      <PageLayout
        title="マスタ管理"
        description="各種マスタデータの管理を行います。"
      >
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">ホーム</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>マスタ管理</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {masterPages.map((page) => (
            <Link
              to={page.href}
              key={page.href}
              className="block hover:no-underline"
            >
              <Card className="h-full hover:shadow-lg transition-shadow duration-200 cursor-pointer">
                <CardHeader>
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-primary/10 rounded-md">
                      <List className="h-6 w-6 text-primary" />
                    </div>
                    <CardTitle>{page.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription>{page.description}</CardDescription>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </PageLayout>
    </AdminPageWrapper>
  )
} 